import { cache } from '@/container/apollo-client/cache';
import { useWorkspaceCounterSubscription } from '@/types/generated/graphql';

export function useWorkspaceCountSubscription() {
  useWorkspaceCounterSubscription({
    onData: (data) => {
      const { workspaceId, counter } = data.data.data?.workspaceCounter || {};
      updateWorkspaceCountInCache(workspaceId, counter);
    },
  });
}

function updateWorkspaceCountInCache(workspaceId: number | null | undefined, counter: number | null | undefined) {
  const workspaceCacheId = cache.identify({
    __typename: 'Workspace',
    id: workspaceId,
  });

  if (!workspaceCacheId) return;

  cache.modify({
    id: workspaceCacheId,
    fields: {
      unreadCountWorkspace() {
        return counter;
      },
    },
  });
}
